import { TResult } from "../../../../sg-core";
import * as V1 from "./versions/IObservationPackageV1";
import { observationPackageConverter } from "./versions/permitPackageConverter";

export enum EObservationPackageVersio {
    v1 = "v1",
};

export type IObservationPackage = V1.IObservationPackageV1;
const validatePermitPackageContent = V1.validateObservationPackageV1;


/**
 * Validates permit package data and runs required conversios to most recent versio 
 * @param uknownData 
 * @returns - Validated and converted package data
 */
export const validateObservationPackage = (uknownData: Partial<IObservationPackage>): TResult<IObservationPackage> => {
    let data = observationPackageConverter(uknownData);
    return validatePermitPackageContent(data);
};